import {
    FETCH_START,
    FETCH_END,
    EXTENSION_LIST_SUCCESS,
    EXTENSION_TABLE_DATA_SUCCESS,
} from '../../../actions/DataSetup/CustomData/ActionTypes';

const initialState = {
    loading: false,
    extensionList: [],
    extensionTableData: {},
};

const CustomDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return {
                ...state,
                loading: true,
            };
        case FETCH_END:
            return {
                ...state,
                loading: false,
            };
        case EXTENSION_LIST_SUCCESS:
            return {
                ...state,
                extensionList: action.data,
            };
        case EXTENSION_TABLE_DATA_SUCCESS:
            return {
                ...state,
                extensionTableData: action.data,
            };
        default:
            return state;
    }
};

export default CustomDataReducer;
